import {
  Text,
  Modal,
  InlineStack,
  BlockStack,
  Grid,
  Form,
  Divider,
  FormLayout,
  TextField,
  SkeletonBodyText,
  ResourceList,
  ResourceItem,
  EmptyState,
  Button,
  Select,
} from '@shopify/polaris';
import { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import helpers from 'helpers/index';
import { ENUM_ORDER_FEE, ORDER_FEE_LABEL, useMutateOrderBooking } from 'queries/orders.query';
import { ConfettiIcon, DuplicateIcon, PlusIcon } from '@shopify/polaris-icons';
import { useNotification } from 'context/NotificationContext';
import __helpers from 'helpers/index';
import { lengthLessThan, notEmpty, useField, useForm } from '@shopify/react-form';
import { TypedUser_address_book, useDeleteUserAddressBooks, useMutateGetUserAddressBooksForButtomBar } from 'queries/user_address_book.query';
import __ from 'languages/index';
import AutocompleteAddress from 'components/addressAutoComplete';
// import QuickSearchUser from 'components/quickSearchUser';
import { TypedUser } from 'interface/user.model';
import { TypedTripData } from 'queries/trip.query';
import { useGetJourney } from 'queries/journey.query';
// import QuickSearchPassenger from 'components/quickSearchPassenger';
import { useGetMapsPlaceDetail } from 'queries/google_maps.suggest.query';
import { TypedAddress_suggestion, useMutateGetAddressSuggestions } from 'queries/address_suggestion.query';
import { useMutateSearchUser } from 'queries/users.query';
import { ENUM_TICKET_TYPE } from 'queries/ticket.query';
import { TypedUser_tax_information, useGetUserTaxInformations } from 'queries/user_tax_information.query';
// import { ResponsivePopover } from 'components/ResponsivePopover';

function takeNumberOnly(input: string): string {
  return input.replace(/\D/g, '');
}

export default function AddTicketModal({
  show,
  seat_position,
  trip_manifest_id,
  tripData,
  currentTicketType,
  onClose,
}: {
  show: boolean;
  seat_position: Array<string | number>;
  trip_manifest_id?: string;
  tripData: TypedTripData;
  currentTicketType: string;
  onClose: () => void;
}) {
  const StringQuery = useMemo(() => {
    const rootSearchPath = window.location.search;
    return helpers.ExtractUrl(rootSearchPath);
  }, [window.location.search]);

  const { addNotification } = useNotification();
  const { mutateAsync: bookAticket, isSuccess: createSuccesfully } = useMutateOrderBooking();

  // debug

  const [currentCustomerData, setCurrentCustomerData] = useState<TypedUser>(null);
  const loadCustomerFromLocal = useCallback(() => {
    try {
      let quickbook_customer_data = sessionStorage.getItem('quickbook_customer_data');
      let quickbook_customer_data_after_parse = JSON.parse(quickbook_customer_data);
      setCurrentCustomerData(quickbook_customer_data_after_parse);
      if (quickbook_customer_data_after_parse && quickbook_customer_data_after_parse.user_phonenumber) {
        useFields.customer_phone.onChange(quickbook_customer_data_after_parse.user_phonenumber);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    loadCustomerFromLocal();
  }, [show]);

  const {
    mutateAsync: mutateGetUserAddressBook,
    data: addressBookData,
    isPending: loadingUserAddressBook,
    reset: resetUserAddressBook,
  } = useMutateGetUserAddressBooksForButtomBar();

  const [userAddressBookData, setUserAddressBookData] = useState<{ from: TypedUser_address_book[]; to: TypedUser_address_book[] }>({
    from: [],
    to: [],
  });
  useEffect(() => {
    if (addressBookData) {
      setUserAddressBookData(addressBookData);
    }
  }, [addressBookData]);

  const { mutateAsync: deleteUserAddressBook } = useDeleteUserAddressBooks();

  const deleteUserAddressCallback = useCallback(
    async (user_address_book_id: string) => {
      try {
        const c = window.confirm('Bạn có chắc chắn muốn xóa địa chỉ này không?');
        if (!c) return;

        await deleteUserAddressBook(user_address_book_id);
        addNotification('info', 'Xóa địa chỉ thành công!');
        setUserAddressBookData((prev) => ({
          from: prev.from.filter((el) => el.user_address_book_id !== user_address_book_id),
          to: prev.to.filter((el) => el.user_address_book_id !== user_address_book_id),
        }));
      } catch (e) {}
    },
    [deleteUserAddressBook, addNotification, setUserAddressBookData]
  );

  /** QUICK BOOK */
  /** QUICK BOOK */
  /** QUICK BOOK */
  /** QUICK BOOK */

  const useFields = {
    /** create new one */
    // trip_time: useField<string>({ value: '', validates: [] }),
    // trip_date: useField<string>({ value: '', validates: [] }),

    /** Edit ... */
    customer_name: useField<string>({
      value: currentCustomerData?.display_name ?? '',
      validates: [notEmpty('Không được để trống.')],
    }),
    customer_phone: useField<string>({
      value: '',
      validates: [
        notEmpty('Không được để trống.'),
        (inputVal) => {
          if (!helpers.isPhoneNumber(inputVal)) return 'Phải là một số điện thoại.';
        },
      ],
    }),
    pickup_address: useField<string>({ value: '', validates: [notEmpty('Trường này không được để trống.')] }),
    // pickup_time: useField<string>({
    //   value: tripData?.time,
    //   validates: [
    //     (inputVal) => {
    //       if (inputVal && !helpers.isValidTime(inputVal)) return 'Giờ định dạng sai (hh:mm)';
    //     },
    //   ],
    // }),
    pickup_place_id: useField<string>({ value: '', validates: [notEmpty('Hãy chọn từ một trong các địa chỉ hợp lệ.')] }),

    pickup_province: useField<string>({ value: '', validates: [] }),
    pickup_district: useField<string>({ value: '', validates: [] }),
    pickup_ward: useField<string>({ value: '', validates: [] }),

    pickup_note: useField<string>({ value: '', validates: [] }),

    /** Case: Đặt hộ */
    pickup_contact_name: useField<string>({ value: '', validates: [] }),
    pickup_contact_phonenumber: useField<string>({
      value: '',
      validates: [
        (inputVal) => {
          if (inputVal && !helpers.isPhoneNumber(inputVal)) return 'Số điện thoại không hợp lệ';
        },
      ],
    }),

    dropoff_address: useField<string>({
      value: '',
      validates: [notEmpty('Trường này không được để trống.')],
    }),
    dropoff_contact_name: useField<string>({
      value: '',
      validates: [],
    }),
    dropoff_contact_phonenumber: useField<string>({
      value: '',
      validates: [],
    }),

    dropoff_place_id: useField<string>({ value: '', validates: [notEmpty('Hãy chọn từ một trong các địa chỉ hợp lệ.')] }),

    dropoff_province: useField<string>({ value: '', validates: [] }),
    dropoff_district: useField<string>({ value: '', validates: [] }),
    dropoff_ward: useField<string>({ value: '', validates: [] }),

    dropoff_note: useField<string>({ value: '', validates: [] }),

    note: useField<string>({ value: '', validates: [lengthLessThan(1000, 'Ghi chú quá dài...')] }),

    /** Lưu ý: Nếu có pricetable thì? */
    // price: useField<number>({
    //   value: tripData?.price || 0,
    //   validates: [
    //     (inputVal) => {
    //       if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
    //     },
    //   ],
    // }),
    // discount: useField<number>({
    //   value: 0,
    //   validates: [
    //     (inputVal) => {
    //       if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
    //       if (Number(inputVal) < 0) return 'Phải là một số dương hợp lệ.';
    //     },
    //   ],
    // }),
    total_fee: useField<number>({
      value: 0,
      validates: [],
    }),

    price_table: useField<{ price: number; discount: number; ticket_type: string; seat_position: string }[]>({
      value: [{ price: 0, discount: 0, ticket_type: String(currentTicketType).toUpperCase(), seat_position: 'trunk' }],
      validates: [],
    }),

    order_fee: useField<{ fee_value: number; fee_description: string }[]>({
      value: [],
      validates: [],
    }),
    user_tax_information_id: useField<string>({ value: '', validates: [] }),
  };

  /** dành để edit field */
  const { data: journeyData } = useGetJourney(StringQuery.journey_id);

  const { data: taxInformationData } = useGetUserTaxInformations({
    user_id: currentCustomerData?.user_id,
    limit: 50,
    sort: 'createdAt:desc',
  });
  const taxInformations = useMemo<TypedUser_tax_information[]>(() => taxInformationData?.body ?? [], [taxInformationData]);
  const taxInformationOptions = useMemo(
    () => [
      { label: 'Không yêu cầu xuất hóa đơn', value: '' },
      ...taxInformations.map((taxInformation) => {
        const baseLabel = taxInformation?.name || taxInformation?.tax_code || 'Thông tin thuế';
        const taxCodeSuffix = taxInformation?.tax_code ? ` - ${taxInformation.tax_code}` : '';
        const defaultSuffix = taxInformation?.is_default ? ' (Mặc định)' : '';
        return {
          label: `${baseLabel}${taxCodeSuffix}${defaultSuffix}`,
          value: String(taxInformation?.id),
        };
      }),
    ],
    [taxInformations]
  );

  useEffect(() => {
    if (taxInformations.length > 0 && !useFields.user_tax_information_id.value) {
      useFields.user_tax_information_id.onChange(String(taxInformations[0].id));
    }
  }, [taxInformations]);

  const { fields, submit, submitting, dirty, makeClean, reset } = useForm({
    fields: useFields,
    async onSubmit(values) {
      try {
        let bookedTicketData = await bookAticket({
          journey_id: StringQuery.journey_id,
          customer_name: values.customer_name,
          customer_phone: values.customer_phone,
          // pickup_time: values.pickup_time,
          pickup_address: values.pickup_address,
          pickup_place_id: values.pickup_place_id,

          pickup_district: values.pickup_district,
          pickup_province: values.pickup_province,
          pickup_ward: values.pickup_ward,
          pickup_note: values.pickup_note,
          pickup_contact_name: values.pickup_contact_name,
          pickup_contact_phonenumber: values.pickup_contact_phonenumber,

          dropoff_address: values.dropoff_address,
          dropoff_contact_name: values.dropoff_contact_name,
          dropoff_contact_phonenumber: values.dropoff_contact_phonenumber,
          dropoff_place_id: values.dropoff_place_id,

          dropoff_district: values.dropoff_district,
          dropoff_province: values.dropoff_province,
          dropoff_ward: values.dropoff_ward,
          dropoff_note: values.dropoff_note,

          note: values.note,
          // price: values.price,
          // discount: values.discount,
          price_table: values.price_table,
          order_fee: values.order_fee /** special */,

          // không cần truyền dữ liệu vào đây ...
          // departure_date: new Date(values.trip_date + ' ' + values.trip_time).getTime(),
          trip_manifest_id: trip_manifest_id,

          /** Lưu profile thuế vào luôn */
          user_tax_information_id: values.user_tax_information_id || null,
        });
        let allTicketIDs = bookedTicketData.map((al) => al.id);
        addNotification('info', `Tổng ${allTicketIDs.length} vé đã được tạo.`);
        // if (trip_manifest_id) await submitTicketIDTOTripManifest(allTicketIDs);
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success', errors: [] };
    },
  });

  /** reset lai form */
  useEffect(() => {
    if (show === false) {
      helpers.resetForm(useFields);
      makeClean();
      resetUserAddressBook();
    }
  }, [show]);

  // ... sau khi khai báo useForm

  // useEffect(() => {
  //   // 1. Chỉ chạy khi có ticketData và có departure_date
  //   if (StringQuery.d) {
  //     try {
  //       // 2. Parse chuỗi ngày giờ từ server

  //       // 3. Format thành 2 phần riêng biệt
  //       const timePart = tripData?.time || '';
  //       const datePart = StringQuery.d;

  //       // 4. Dùng hàm onChange của field để cập nhật giá trị mới cho form
  //       fields.trip_time.onChange(timePart);
  //       fields.trip_date.onChange(datePart);
  //     } catch (error) {
  //       console.error('Lỗi khi định dạng ngày giờ:', error);
  //       // Có thể reset field về rỗng nếu ngày giờ lỗi
  //       fields.trip_time.onChange('');
  //       fields.trip_date.onChange('');
  //     }
  //   }
  // }, [StringQuery.d, tripData?.time]);

  const getCustomerAddress = useCallback(
    (user_id) => {
      if (show === true) {
        mutateGetUserAddressBook({
          journey_id: String(StringQuery?.journey_id),
          user_id: user_id,
        });
      }
    },
    [StringQuery, show]
  );

  useEffect(() => {
    if (!currentCustomerData) {
      /** Không có thông tin khách hàng thì xóa mẹ nó đi */
      setUserAddressBookData({ from: [], to: [] });
      useFields.user_tax_information_id.onChange('');
      return;
    }
    useFields.user_tax_information_id.onChange('');
    getCustomerAddress(currentCustomerData?.user_id);
  }, [currentCustomerData]);

  useEffect(() => {
    if (createSuccesfully) {
      sessionStorage.removeItem('quickbook_customer_data');
      onClose();
    }
  }, [createSuccesfully]);

  /** tính toán tổng phải thanh toán */
  const [totalMustPay, setTotalMustPay] = useState<number>(0);
  useEffect(() => {
    const fee = Number(fields.total_fee.value || 0);
    let totalMustPay = 0;

    let allPriceTable = useFields.price_table.value;
    for (let priceTag of allPriceTable) {
      totalMustPay += priceTag.price - priceTag.discount;
    }
    setTotalMustPay(totalMustPay + fee);
  }, [fields.price_table.value, fields.total_fee.value]);

  useEffect(() => {
    if (helpers.isEmpty(useFields.order_fee.value)) return;
    let total_fee = 0;
    for (let d of useFields.order_fee.value) {
      total_fee += d.fee_value;
    }
    useFields.total_fee.onChange(total_fee);
  }, [useFields.order_fee.value]);

  /** Tính khoảng cách và chi phí thêm */
  const { mutateAsync: getLatlongfromPlaceID } = useGetMapsPlaceDetail();
  const upsertOrderFee = useCallback(
    (feeDescription: string, feeValue: number) => {
      const normalizedFeeValue = helpers.parseNumeric(feeValue);
      const currentFees = [...fields.order_fee.value];
      const targetIndex = currentFees.findIndex((fee) => fee.fee_description === feeDescription);

      if (normalizedFeeValue > 0) {
        if (targetIndex >= 0) {
          currentFees[targetIndex] = { ...currentFees[targetIndex], fee_value: normalizedFeeValue };
          fields.order_fee.onChange(currentFees);
          return;
        }
        fields.order_fee.onChange([
          ...currentFees,
          {
            fee_value: normalizedFeeValue,
            fee_description: feeDescription,
          },
        ]);
        return;
      }

      if (targetIndex >= 0) {
        fields.order_fee.onChange(currentFees.filter((_, idx) => idx !== targetIndex));
      }
    },
    [fields.order_fee.value]
  );

  const applyExtraInfoFromAddress = useCallback(
    ({
      extra_price,
      note,
      pickup_or_dropoff = 'pickup',
    }: {
      extra_price?: number | string;
      note?: string;
      pickup_or_dropoff?: 'pickup' | 'dropoff';
    }) => {
      if (pickup_or_dropoff === 'pickup') {
        if (extra_price !== undefined && extra_price !== null) {
          upsertOrderFee('PICKUP_FEE', Number(extra_price));
        }
        if (note) {
          setShowPickupNote(true);
        }
        fields.pickup_note.onChange(note);
        return;
      }

      if (extra_price !== undefined && extra_price !== null) {
        upsertOrderFee('DROPOFF_FEE', Number(extra_price));
      }
      if (note) {
        setShowDropoffNote(true);
      }
      fields.dropoff_note.onChange(note);
    },
    [fields.pickup_note, fields.dropoff_note, upsertOrderFee]
  );

  const fetchExtraInfoFromSavingAddress = useCallback(
    async (item, pickup_or_dropoff: any = 'pickup') => {
      try {
        let { user_address_meta } = item;
        let { extra_price, note, place_id } = user_address_meta;
        applyExtraInfoFromAddress({ extra_price, note, pickup_or_dropoff });

        /** place_id thì mới truy vấn ... */
        if (place_id) {
          let { lat, lng, commune, province } = await getLatlongfromPlaceID(place_id);
          if (pickup_or_dropoff === 'pickup') {
            fields.pickup_province.onChange(province);
            fields.pickup_ward.onChange(commune);
          } else {
            fields.dropoff_province.onChange(province);
            fields.dropoff_ward.onChange(commune);
          }
        }
      } catch (e) {}
    },
    [fields, applyExtraInfoFromAddress, getLatlongfromPlaceID]
  );

  /** Ghi chú điểm đón trả */
  const [showPickupNote, setShowPickupNote] = useState(false);
  const [showDropoffNote, setShowDropoffNote] = useState(false);

  /** Lấy địa chỉ gợi ý */
  const { mutateAsync: getAddressSuggestion } = useMutateGetAddressSuggestions();
  const [suggestDataFrom, setSuggestDataFrom] = useState<TypedAddress_suggestion[]>([]);
  const [suggestDataTo, setSuggestDataTo] = useState<TypedAddress_suggestion[]>([]);

  const fetchSuggestionData = useCallback(async () => {
    let FromData = await getAddressSuggestion({
      journey_from_id: journeyData.journey_from_province_id,
      journey_id: journeyData.id,
      limit: 5,
    });
    if (!helpers.isEmpty(FromData)) setSuggestDataFrom(FromData);

    let ToData = await getAddressSuggestion({
      journey_from_id: journeyData.journey_to_province_id,
      journey_id: journeyData.id,
      limit: 5,
    });
    if (!helpers.isEmpty(ToData)) setSuggestDataTo(ToData);
  }, [journeyData]);

  useEffect(() => {
    if (!journeyData || helpers.isEmpty(journeyData)) return;
    fetchSuggestionData();
  }, [journeyData]);

  const fromClipboard = useCallback(async () => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      fields.customer_phone.onChange(takeNumberOnly(clipboardText));
    } catch (e) {}
  }, []);

  const { mutateAsync: searchUser } = useMutateSearchUser();
  const loadCustomerDataSuggestion = useCallback(async (phonenumber: string) => {
    try {
      let customerData = await searchUser({
        user_phonenumber: phonenumber,
      });
      if (!helpers.isEmpty(customerData)) {
        setCurrentCustomerData(customerData[0]);
      }
    } catch (e) {}
  }, []);

  const lastSearchedPhone = useRef<string>('');
  const searchCustomerDebounce = useMemo(
    () =>
      helpers.debounce((value: string) => {
        if (!value || value === lastSearchedPhone.current) return;
        lastSearchedPhone.current = value;
        loadCustomerDataSuggestion(value);
      }, 400),
    [loadCustomerDataSuggestion]
  );

  useEffect(() => {
    const normalizedPhone = takeNumberOnly(fields.customer_phone.value);
    if (helpers.isPhoneNumber(normalizedPhone)) {
      searchCustomerDebounce(normalizedPhone);
    } else {
      lastSearchedPhone.current = '';
    }
  }, [fields.customer_phone.value, searchCustomerDebounce]);

  const { mutateAsync: searchPickupContact } = useMutateSearchUser();
  const loadPickupContactSuggestion = useCallback(async (phonenumber: string) => {
    try {
      const pickupContactData = await searchPickupContact({
        user_phonenumber: phonenumber,
      });
      if (!helpers.isEmpty(pickupContactData)) {
        fields.pickup_contact_name.onChange(pickupContactData[0].display_name ?? '');
      }
    } catch (e) {}
  }, []);

  const lastSearchedPickupContactPhone = useRef<string>('');
  const searchPickupContactDebounce = useMemo(
    () =>
      helpers.debounce((value: string) => {
        if (!value || value === lastSearchedPickupContactPhone.current) return;
        lastSearchedPickupContactPhone.current = value;
        loadPickupContactSuggestion(value);
      }, 400),
    [loadPickupContactSuggestion]
  );

  useEffect(() => {
    const normalizedPhone = takeNumberOnly(fields.pickup_contact_phonenumber.value);
    if (helpers.isPhoneNumber(normalizedPhone)) {
      searchPickupContactDebounce(normalizedPhone);
    } else {
      lastSearchedPickupContactPhone.current = '';
    }
  }, [fields.pickup_contact_phonenumber.value, searchPickupContactDebounce]);

  /** Ai thu tiền? */
  const [popoverActive, setPopoverActive] = useState(false);

  /** set gía khi edit */
  useEffect(() => {
    if (!seat_position) return;
    let is_shipment = currentTicketType === ENUM_TICKET_TYPE.SHIPMENT;
    let price_table = [];
    for (let seat of seat_position) {
      if (is_shipment)
        price_table.push({
          price: Number(tripData?.shipping_price || 0),
          discount: 0,
          ticket_type: String(currentTicketType).toUpperCase(),
          seat_position: seat,
        });
      else
        price_table.push({
          price: Number(tripData?.price || 0),
          discount: 0,
          ticket_type: String(currentTicketType).toUpperCase(),
          seat_position: seat,
        });
    }
    useFields.price_table.onChange(price_table);
  }, [seat_position, tripData, currentTicketType]);

  /** Show form thêm thông tin đón */
  const [showPickUpContactInformation, setShowPickUpContactInformation] = useState(false);

  /** Thêm phí */

  const handleAddOrderFee = useCallback(() => {
    useFields.order_fee.onChange([...useFields.order_fee.value, { fee_description: 'PICKUP_FEE', fee_value: 0 }]);
  }, [useFields.order_fee.value]);

  // đặt gần các hook khác
  const handlePriceChange = useCallback(
    (raw: string, index: number) => {
      const newPrice = __helpers.parseNumeric(raw);
      const list = [...useFields.price_table.value];

      if (index === 0) {
        // cập nhật đồng loạt tất cả vé theo giá của vé #1
        const updated = list.map((it) => ({ ...it, price: newPrice }));
        useFields.price_table.onChange(updated);
      } else {
        // chỉ cập nhật vé đang sửa
        list[index] = { ...list[index], price: newPrice };
        useFields.price_table.onChange(list);
      }
    },
    [useFields.price_table.value]
  );

  // Nuts copy
  const copyReceiverFromSenderCallback = useCallback(() => {
    useFields.dropoff_contact_name.onChange(useFields.customer_name.value);
    useFields.dropoff_contact_phonenumber.onChange(useFields.customer_phone.value);
  }, [useFields.customer_name.value, useFields.customer_phone.value]);

  return (
    <>
      <Modal
        size="large"
        open={show}
        title={`Đặt vé ${currentTicketType === ENUM_TICKET_TYPE.SHIPMENT ? 'hàng' : 'khách'} cho chuyến ${tripData?.time || '?'} ngày ${StringQuery.d ?? 'chưa rõ'}`}
        onClose={() => onClose()}
        primaryAction={{
          content: `Đặt`,
          icon: ConfettiIcon,
          disabled: !dirty || totalMustPay < 0,
          loading: submitting,
          onAction: submit,
        }}
      >
        <Modal.Section>
          {!tripData?.time ? (
            <EmptyState
              image={''}
              heading="Chưa chọn chuyến nào"
              footerContent={<Text as="p">Chọn vào một chuyến trước rồi bấm nút đặt lại.</Text>}
            />
          ) : (
            <Form onSubmit={submit}>
              <Grid columns={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                <Grid.Cell>
                  <BlockStack gap={{ xs: '200', sm: '400' }}>
                    <FormLayout.Group>
                      <TextField
                        label="SĐT"
                        placeholder="Số điện thoại"
                        autoComplete="off"
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        disabled={submitting}
                        clearButton
                        value={fields.customer_phone.value}
                        onChange={(v) => {
                          fields.customer_phone.onChange(takeNumberOnly(v));
                          // searchCustomerDebound();
                        }}
                        // onBlur={() => loadCustomerDataSuggestion()}
                        error={fields.customer_phone.error}
                        onClearButtonClick={() => {
                          fields.customer_phone.onChange('');
                          setCurrentCustomerData(null);
                        }}
                        labelAction={{
                          content: 'Dán',
                          onAction: () => {
                            fromClipboard();
                          },
                        }}
                      />

                      <TextField
                        autoComplete="off"
                        placeholder="Tên khách hàng"
                        label="Tên"
                        {...fields.customer_name}
                        onChange={(e) => fields.customer_name.onChange(helpers.capitalizeWords(e))}
                        disabled={submitting}
                        clearButton
                        onClearButtonClick={() => fields.customer_name.onChange('')}
                      />
                    </FormLayout.Group>
                    <BlockStack gap="200">
                      <div>
                        <Button variant="plain" icon={PlusIcon} onClick={() => setShowPickUpContactInformation((old) => !old)}>
                          Đặt hộ người khác?
                        </Button>
                      </div>

                      {showPickUpContactInformation ? (
                        <FormLayout.Group>
                          <TextField
                            label=""
                            placeholder="Số điện thoại"
                            autoComplete="off"
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            disabled={submitting}
                            clearButton
                            value={fields.pickup_contact_phonenumber.value}
                            onChange={(v) => {
                              fields.pickup_contact_phonenumber.onChange(takeNumberOnly(v));
                            }}
                            error={fields.pickup_contact_phonenumber.error}
                            onClearButtonClick={() => {
                              fields.pickup_contact_phonenumber.onChange('');
                              fields.pickup_contact_name.onChange('');
                            }}
                          />

                          <TextField
                            autoComplete="off"
                            placeholder="Tên khách hàng"
                            label=""
                            {...fields.pickup_contact_name}
                            onChange={(e) => fields.pickup_contact_name.onChange(helpers.capitalizeWords(e))}
                            disabled={submitting}
                            clearButton
                            onClearButtonClick={() => fields.pickup_contact_name.onChange('')}
                          />
                        </FormLayout.Group>
                      ) : null}
                    </BlockStack>
                    <Divider />
                    <AutocompleteAddress
                      address_suggestion={suggestDataFrom}
                      autoComplete="off"
                      journey_id={StringQuery.journey_id}
                      latlong={journeyData?.journey_from_lat_long}
                      placeholder={'Địa chỉ đón'}
                      prependAddress={journeyData?.journey_from}
                      label={`Đón tại ` + journeyData?.journey_from}
                      selectedCallback={(out) => {
                        let { latlng, ward, province, extra_price, note, pickup_support, position_name } = out;
                        useFields.pickup_place_id.onChange(latlng);
                        useFields.pickup_province.onChange(province);
                        useFields.pickup_ward.onChange(ward);
                        applyExtraInfoFromAddress({
                          extra_price,
                          note: note || position_name ? `[Vùng: ${position_name}${pickup_support === 0 ? ' **Không hỗ trợ**' : ''}] ${note}` : '',
                          pickup_or_dropoff: 'pickup',
                        });
                        // end
                      }}
                      {...useFields.pickup_address}
                      disabled={submitting}
                      labelAction={{
                        content: 'Thêm thông tin',
                        onAction: () => {
                          if (showPickupNote) {
                            setShowPickupNote(false);
                            fields.pickup_note.onChange('');
                          } else {
                            setShowPickupNote(true);
                          }
                        },
                      }}
                      error={useFields.pickup_place_id.error}
                    />
                    {showPickupNote && (
                      <>
                        <TextField
                          tone="magic"
                          multiline={2}
                          autoComplete="off"
                          label="Ghi chú điểm đón"
                          autoFocus
                          placeholder="Ghi chú"
                          {...fields.pickup_note}
                        />
                        {/* <TextField autoComplete="off" label="Đón lúc" placeholder="hh:mm" {...fields.pickup_time} /> */}
                      </>
                    )}
                    {loadingUserAddressBook ? (
                      <SkeletonBodyText />
                    ) : helpers.isEmpty(userAddressBookData?.from) ? (
                      <Text as="p" tone="subdued">
                        Chưa có thông tin lưu sẵn
                      </Text>
                    ) : (
                      <ResourceList
                        resourceName={{ singular: 'Địa chỉ đón', plural: 'Địa chỉ đón' }}
                        items={userAddressBookData?.from || []}
                        renderItem={(item, index) => {
                          return (
                            <ResourceItem
                              id={item.user_address_book_id}
                              onClick={() => {
                                useFields.pickup_address.onChange(item.user_address);
                                useFields.pickup_place_id.onChange(item.user_address_place_id);
                                useFields.pickup_province.onChange(item.user_address_province);
                                useFields.pickup_ward.onChange(item.user_address_ward);
                                useFields.pickup_note.onChange(item.note);
                                if (item.note) {
                                  setShowPickupNote(true);
                                }
                                fetchExtraInfoFromSavingAddress(item, 'pickup');
                              }}
                              shortcutActions={[
                                {
                                  content: 'Xoá',
                                  onAction: () => deleteUserAddressCallback(item.user_address_book_id),
                                },
                              ]}
                              persistActions
                            >
                              <Text fontWeight="bold" as="p" tone="subdued">
                                {item.user_address}
                              </Text>
                              {item.note && (
                                <Text as="p" tone="critical">
                                  ⚠ {item.note}
                                </Text>
                              )}
                            </ResourceItem>
                          );
                        }}
                      />
                    )}
                    <AutocompleteAddress
                      autoComplete="off"
                      journey_id={StringQuery.journey_id}
                      address_suggestion={suggestDataTo}
                      prependAddress={journeyData?.journey_to}
                      latlong={journeyData?.journey_to_lat_long}
                      placeholder="Địa chỉ xuống"
                      label={`Xuống tại ` + journeyData?.journey_to}
                      selectedCallback={({ latlng, ward, province, extra_price, note, pickup_support, position_name }) => {
                        useFields.dropoff_place_id.onChange(latlng);
                        useFields.dropoff_province.onChange(province);
                        useFields.dropoff_ward.onChange(ward);
                        applyExtraInfoFromAddress({
                          extra_price,
                          note: note || position_name ? `[Vùng: ${position_name}${pickup_support === 0 ? ' **Không hỗ trợ**' : ''}] ${note}` : '',
                          pickup_or_dropoff: 'dropoff',
                        });
                      }}
                      {...useFields.dropoff_address}
                      disabled={submitting}
                      labelAction={{
                        content: 'Thêm ghi chú',
                        onAction: () => {
                          if (showDropoffNote) {
                            setShowDropoffNote(false);
                            fields.dropoff_note.onChange('');
                          } else {
                            setShowDropoffNote(true);
                          }
                        },
                      }}
                      error={useFields.dropoff_place_id.error}
                    />
                    {showDropoffNote && (
                      <TextField autoComplete="off" autoFocus label="Ghi chú điểm trả" placeholder="Ghi chú" {...fields.dropoff_note} />
                    )}
                    {loadingUserAddressBook ? (
                      <SkeletonBodyText />
                    ) : helpers.isEmpty(userAddressBookData?.to) ? (
                      <Text as="p" tone="subdued">
                        Chưa có thông tin lưu sẵn
                      </Text>
                    ) : (
                      <ResourceList
                        resourceName={{ singular: 'Địa chỉ trả', plural: 'Địa chỉ trả' }}
                        items={userAddressBookData?.to || []}
                        renderItem={(item, index) => {
                          return (
                            <ResourceItem
                              id={item.user_address_book_id}
                              // url={''}
                              onClick={() => {
                                useFields.dropoff_address.onChange(item.user_address);
                                useFields.dropoff_place_id.onChange(item.user_address_place_id);
                                useFields.dropoff_province.onChange(item.user_address_province);
                                useFields.dropoff_ward.onChange(item.user_address_ward);
                                useFields.dropoff_note.onChange(item.note);
                                if (item.note) {
                                  setShowDropoffNote(true);
                                }
                                fetchExtraInfoFromSavingAddress(item, 'dropoff');
                              }}
                              shortcutActions={[
                                {
                                  content: 'Xoá',
                                  onAction: () => deleteUserAddressCallback(item.user_address_book_id),
                                },
                              ]}
                              persistActions
                            >
                              <Text fontWeight="bold" as="p" tone="subdued">
                                {item.user_address}
                              </Text>
                              {item.note && (
                                <Text as="p" tone="critical">
                                  ⚠ {item.note}
                                </Text>
                              )}
                            </ResourceItem>
                          );
                        }}
                      />
                    )}

                    {currentTicketType && currentTicketType === ENUM_TICKET_TYPE.SHIPMENT && (
                      <BlockStack gap="400" inlineAlign="start">
                        <Divider />
                        <Text as="h3" variant="headingMd">
                          Thông tin người nhận hàng
                        </Text>
                        <FormLayout.Group condensed>
                          <TextField
                            autoComplete="off"
                            label={`Tên người nhận hàng`}
                            {...fields.dropoff_contact_name}
                            requiredIndicator
                            disabled={submitting}
                          />
                          <TextField
                            autoComplete="off"
                            label={`Số liên lạc`}
                            {...fields.dropoff_contact_phonenumber}
                            requiredIndicator
                            disabled={submitting}
                          />
                        </FormLayout.Group>
                        <Button
                          icon={DuplicateIcon}
                          variant="plain"
                          onClick={() => {
                            copyReceiverFromSenderCallback();
                          }}
                        >
                          Copy thông tin từ người đặt
                        </Button>
                      </BlockStack>
                    )}
                    {!helpers.isEmpty(taxInformations) && (
                      <Select
                        label="Profile thuế đã lưu"
                        options={taxInformationOptions}
                        value={fields.user_tax_information_id.value}
                        onChange={fields.user_tax_information_id.onChange}
                        disabled={submitting}
                      />
                    )}
                  </BlockStack>
                </Grid.Cell>
                <Grid.Cell>
                  <BlockStack gap={{ xs: '200', sm: '400' }}>
                    <TextField
                      autoComplete="off"
                      multiline={2}
                      label="Ghi chú đơn hàng"
                      showCharacterCount
                      maxLength={1000}
                      {...fields.note}
                      disabled={submitting}
                    />
                    <Text as="h3" variant="headingMd">
                      Phí xử lý đơn
                    </Text>
                    {useFields.order_fee.value?.map((feeData, index) => {
                      return (
                        <FormLayout.Group key={`order_fee_${index}`}>
                          <Select
                            label="Chọn:"
                            labelInline
                            options={helpers.enumToArray(ENUM_ORDER_FEE).map((el) => {
                              return {
                                label: ORDER_FEE_LABEL[el],
                                value: el,
                              };
                            })}
                            onChange={(a) => {
                              const updatedPriceTable = [...useFields.order_fee.value];
                              updatedPriceTable[index] = { ...updatedPriceTable[index], fee_description: a };
                              useFields.order_fee.onChange(updatedPriceTable);
                            }}
                            value={feeData.fee_description}
                          />
                          <TextField
                            autoComplete="off"
                            label={``}
                            type="tel"
                            placeholder="Số tiền"
                            inputMode="numeric"
                            pattern="[0-9.,]*"
                            value={__helpers.formatNumber(feeData.fee_value)}
                            onChange={(a) => {
                              const updatedPriceTable = [...useFields.order_fee.value];
                              updatedPriceTable[index] = { ...updatedPriceTable[index], fee_value: __helpers.parseNumeric(a) };
                              useFields.order_fee.onChange(updatedPriceTable);
                            }}
                            disabled={submitting}
                          />
                        </FormLayout.Group>
                      );
                    })}
                    <div>
                      <Button icon={PlusIcon} variant="plain" onClick={handleAddOrderFee}>
                        Thêm phí
                      </Button>
                    </div>

                    <Text as="h3" variant="headingMd">
                      Giá vé
                    </Text>

                    {useFields.price_table.value.map((el, index) => {
                      return (
                        <FormLayout.Group condensed key={`price_${index}_${el.seat_position}`}>
                          <TextField
                            autoComplete="off"
                            label={`Giá vé #${index + 1}`}
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9.,]*"
                            value={__helpers.formatNumber(el.price)}
                            onChange={(a) => handlePriceChange(a, index)} // ⬅️ dùng handler
                            disabled={submitting}
                          />
                          <TextField
                            autoComplete="off"
                            label="Giảm giá"
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={__helpers.formatNumber(el.discount)}
                            // onChange={(a) => {
                            //   fields.discount.onChange(helpers.parseNumeric(a));
                            // }}
                            onChange={(a) => {
                              const updatedPriceTable = [...useFields.price_table.value];
                              updatedPriceTable[index] = { ...updatedPriceTable[index], discount: __helpers.parseNumeric(a) };
                              useFields.price_table.onChange(updatedPriceTable);
                            }}
                            disabled={submitting}
                          />
                        </FormLayout.Group>
                      );
                    })}

                    <Divider />

                    <InlineStack align="space-between" blockAlign="center">
                      <Text as="span" fontWeight="bold">
                        Số chỗ
                      </Text>
                      <Text as="h3" fontWeight="bold" variant="headingMd" tone="critical">
                        {__helpers.formatNumber(seat_position.length)} chỗ
                      </Text>
                    </InlineStack>
                    <InlineStack align="space-between" blockAlign="center">
                      <Text as="span" fontWeight="bold">
                        Giá vé
                      </Text>
                      <Text as="h3" fontWeight="bold" variant="headingMd" tone="critical">
                        {__helpers.formatNumber(tripData?.price)}
                      </Text>
                    </InlineStack>
                    <InlineStack align="space-between" blockAlign="center">
                      <Text as="span" fontWeight="bold">
                        Tổng phải thanh toán
                      </Text>
                      <Text as="h3" fontWeight="bold" variant="headingLg" tone="critical">
                        {__helpers.formatNumber(totalMustPay)}
                      </Text>
                    </InlineStack>
                  </BlockStack>
                </Grid.Cell>
              </Grid>
            </Form>
          )}
        </Modal.Section>
      </Modal>
    </>
  );
}
